import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getMandantes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/mandantes?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearMandante = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/mandantes', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateMandante = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/mandantes/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteMandante = (Id) => Axios.delete(`/mandantes/${Id}`);
